/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-15 08:59:03
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-16 09:02:02
 * @FilePath: \blackSmokeTruck1\src\assets\js\base.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 环境配置文件
 */

export default {
  // 测试环境地址
  // 线上环境地址
  development: {
    env: 'development', // 环境名称
    baseUrl: 'http://www.kczglidar.com/kcsoft', // 服务端接口路径   
    // baseUrl: 'http://112.123.8.6:8200', // 服务端接口路径
    // baseUrl: 'http://192.168.1.174:9094', // 服务端接口路径

    // project: '/truck',
    project: '/f',
    package: ''
  },
  production: {
    env: 'production', //环境名称
    baseUrl: 'http://www.kczglidar.com/kcsoft', // 服务端接口路径
    project: '/f',
    package: ''
  },
}[process.env.NODE_ENV || 'development']



// WEBPACK FOOTER //
// ./src/assets/js/base.js